<template lang="pug">
  .lista-equipo.contenedor-interno
    .title
      span Mi equipo
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close


    .body
      .message.is-info(v-if="isShowingJefeDirecto")
        .message-body
          strong *
          span Los empleados con texto resaltado son empleados directos, es decir, es tu responsabilidad solicitar la renovación
          span del contrato de ellos.
      loading(v-if="isLoading")
      .is-desktop(v-if="!isLoading")
        table.table.is-bordered
          thead
            th Empleado
            th Fecha Ingreso
            th(v-if="isShowingJefeDirecto") Jefe directo
            th Fecha de fin de contrato
          tbody(
            name="table-row"
            is="transition-group"
          )
            tr.row-table(
              v-for="(o,index) in equipo"
              :key="index+'-desktop'"
              :class="{ directo: o.directo, 'row-info': o.esDeDelegacion }"
            )
              td
                span.name.hint--top(:aria-label="'Empleado: ' + o.dni")
                  | {{ o.nombre }}
                br
                span.email  ({{ o.cargo }})
              td
                .wrapper
                  span {{ o.fechaIngreso }}
                  template(v-if="!o.contratoIndeterminado")
                    template(v-if="o.diasParaIndeterminado < 0")
                      span.has-text-bold Ya deberia ser indeterminado
                    template(v-else)
                      span.has-text-bold Indeterminado en:&nbsp
                      span {{ o.diasParaIndeterminado + ' días' }}
              td(v-if="isShowingJefeDirecto")
                .hint--top(:aria-label="'Jefe: ' + o.dniJefe")
                  | {{ o.nombreJefe }}
              td.contrato
                div(v-if="o.contratoIndeterminado === 1")
                  span Contrato indeterminado
                div(v-if="o.contratoIndeterminado === -1")
                  span Se indico que no se debe renovar
                div(v-if="o.contratoIndeterminado === 0")
                  div(v-if="o.fechaFinContrato")
                    span {{ o.fechaFinContrato }}
                    br
                    span.email
                      | Faltan&nbsp;
                      strong {{ o.diasVencimientoContrato }}&nbsp;
                      | días para el vencimiento del contrato
                    pedir-una-renovacion(
                      v-if="(o.directo || o.codigoJefe === +codigoLogueadoJefe) && o.diasVencimientoContrato <= 15 && mostrarRenovacion"
                      :codigo="o.codigo"
                      :nombre="o.nombre"
                      :idSolicitud = "o.idSolicitudRenovacion"
                      :descripcionEstado = "o.solicitudEstadoDescripcion"
                      @closeRefresh="refreshRenovar"
                    )
                  span(v-else) No se ha enviado la información desde planillas
      .is-mobile(v-if="!isLoading")
        .box.has-text-left.bg-white(
            v-for="(o, index) in equipo"
            :key="index+'-mobile'"
          )
          div.mt-10.hint--top(:aria-label="'Empleado: ' + o.dni")
            span.name {{ o.nombre }}
          div
            span.text-small Cargo:&nbsp;
            span {{ o.cargo }}
          div
            span.text-small Fecha de Ingreso:&nbsp;
            span {{ o.fechaIngreso }}
          div(v-if="!o.contratoIndeterminado")
            template(v-if="o.diasParaIndeterminado < 0")
              span.has-text-bold Ya deberia ser indeterminado
            template(v-else)
              span.has-text-bold Indeterminado en:&nbsp;
              span {{ o.diasParaIndeterminado + ' días' }}
          div
            span.text-small Fin de Contrato:&nbsp;
            span(v-if="o.contratoIndeterminado === 1") Contrato indeterminado
            span(v-if="o.contratoIndeterminado === -1") Se indico que no se debe renovar
            template(v-if="o.contratoIndeterminado === 0")
              template(v-if="o.fechaFinContrato")
                span {{ o.fechaFinContrato }}
                br
                span.text-small
                  | Faltan&nbsp;
                  strong {{ o.diasVencimientoContrato }}&nbsp;
                  | días para el vencimiento del contrato
              span(v-else) No se ha enviado la información desde planillas
          div.hint--top(v-if="codigoLogueadoJefe !== (o.codigoJefe + '')", :aria-label="'Jefe: ' + o.dniJefe")
            span.text-small Jefe:&nbsp;
            span {{ o.nombreJefe }}
          div(v-if="o.contratoIndeterminado === 0")
            template(v-if="o.fechaFinContrato")
              pedir-una-renovacion(
                      v-if="o.directo && o.diasVencimientoContrato <= 15 && mostrarRenovacion"
                      :codigo="o.codigo"
                      :nombre="o.nombre"
                      :idSolicitud = "o.idSolicitudRenovacion"
                      :descripcionEstado = "o.solicitudEstadoDescripcion"
                      @closeRefresh="refreshRenovar"
                    )

</template>

<script>
import { apiGet, notify } from '../util/general'
import ComponentContratosPedirUnaRenovacion from './Component_Contratos_Pedir_Una_Renovacion'

export default {
  name: 'lista_equipo_contratos_component',
  data () {
    return {
      equipo: [],
      mostrarRenovacion: true,
      isLoading: false,
      codigoLogueadoJefe:localStorage.getItem('codigo') + '',
      isShowingJefeDirecto: true
    }
  },
  components: {
    'pedir-una-renovacion': ComponentContratosPedirUnaRenovacion
  },
  created () {
    this.fetch()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/contratos/empleado/equipo/cascada', obj, function (data) {
        vm.equipo = data.lista
        let contador = 0
        // validacion para verificar si el codigo del jefe logueado es igual al codigo del jefe del array entero
        vm.equipo.forEach(function (element, index) {
          if (vm.codigoLogueadoJefe === (element.codigoJefe + '')) {
            contador += 1
          }
        })
        if (contador === vm.equipo.length) {
          vm.isShowingJefeDirecto = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    refreshRenovar () {
      var vm = this
      vm.mostrarRenovacion = false
      setTimeout(function () {
        vm.mostrarRenovacion = true
      }, 300)
      vm.fetch()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .wrapper
    display flex
    justify-content left
    align-items left
    flex-direction column
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase

  th
    text-align center

  .contenedor-acciones
    display flex
    .button
      flex 1
      margin 0px 5px

  .row-table
    transition all 0.3s ease

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }


  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000

  .directo
    font-weight: bold;

    &:hover
      font-weight: bold;

  td
    vertical-align: middle;
    .email
      font-size 12px
      color #9a9a9a
    &.contrato
      font-weight: normal !important

  .box
    background-color: rgba(223, 222, 255, 0.65);
  .is-mobile
    display none
    .box
      position: relative
  .text-small
    font-size 12px
    color #9a9a9a
  @media (max-width 895px)
    .is-mobile
      display block
    .bg-white
      background-color: #fff

    .is-desktop
      display none

    .dias
      display flex
      position: absolute
      top: 3px
      right: 6px
      align-items: center

    .name
      font-size: 16px;

</style>



// WEBPACK FOOTER //
// Component_Contratos_Lista_Equipo.vue?194d87fb